import React, { useState } from "react";
import {
  Berry,
  Claire,
  Evelyn,
  JulianImage,
  fadeUp,
  fadeRightToLeft,
} from "../";
import FormatQuoteRoundedIcon from "@mui/icons-material/FormatQuoteRounded";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { motion } from "framer-motion";
import { useRef } from "react";
import { useEffect } from "react";

const OurLeadership = () => {
  const [showModal, setShowModal] = useState(false);
  const [
    { leaderName, leaderDescription, leaderImage, testimonial },
    setTutor,
  ] = useState({});
  const handleClick = (e) => {
    const targetIndex = e.target.getAttribute("data-index");
    setTutor({
      leaderName: leaderToDisplay[targetIndex].name,
      leaderDescription: leaderToDisplay[targetIndex].description,
      leaderImage: leaderToDisplay[targetIndex].imageUrl,
      testimonial: leaderToDisplay[targetIndex].testimonial,
    });
    setShowModal(true);
  };

  const people = [
    {
      name: "Julian",
      role: "Primary English | Primary Mathematics | Secondary English | Secondary Mathematics",
      imageUrl: JulianImage,
      position: "Director",
      description:
        "Julian Jom is the Director of TutorWo. He holds a Master of Education (Educational Management) from the University of Melbourne and possesses extensive teaching and educational leadership experience across two of Australia's leading independent schools in Melbourne's southeast. One of Julian's niches is his proven track record in leading teaching teams to producing strong student academic results driven by cutting-edge, research-based pedagogical practices. He has coached, mentored, and trained many teachers in best practice as a school middle leader. Julian was also previously a sessional lecturer at one of Melbourne's tertiary institutions where he taught student teachers who were completing their Bachelor of Education and Master of Teaching degrees. Julian's wealth of experience and success in educational and organisational leadership, teaching and learning, innovation, and staff development and capacity building are instrumental to ensuring the highest quality of teaching and learning at TutorWo.",
      //   subjects: [
      //     ["Primary English", languageTag],
      //     ["Primary Mathematics", numberTag],
      //     ["Secondary English", languageTag],
      //     ["Secondary Mathematics", numberTag],
      //   ],
    },
    {
      name: "Berry",
      role: "Primary English | Primary Mathematics | Secondary English | Secondary Mathematics | VCE Chinese | VCE English | VCE Mathematics - General",
      imageUrl: Berry,
      position: "Associate Director",
      description:
        "Berry is the Associate Director of TutorWo and an experienced tutor who graduated from the VCE with an ATAR of 98, making her the international dux of her school. She excelled in VCE Chinese and English, with her Study Scores ranking within the top 2 percent and 0.5 percent in Victoria, respectively. Berry was School Captain and in her final years of schooling was awarded the All Rounder Award Winner from Ampol, Young Volunteer of the Year from Manningham Council, the VGLA (Victorian Global Learning Awards) Student Leadership Award Winner from the Victorian Department of Education, and the Australian Olympic Changemaker from the Australian Olympic Committee. She is currently studying the Bachelor of Vision Science/ Master of Optometry. In addition to being of great help for students in academics, Berry will also be an outstanding role model given her academic, leadership, and community achievements.",
      //   subjects: [
      //     ["Primary English", languageTag],
      //     ["Primary Mathematics", numberTag],
      //     ["Secondary English", languageTag],
      //     ["Secondary Mathematics", numberTag],
      //     ["VCE Chinese", languageTag],
      //     ["VCE English", languageTag],
      //     ["VCE Mathematics - General", numberTag],
      //   ],
    },
    {
      name: "Claire",
      role: "Primary English | Primary Mathematics | Secondary English | VCE English | VCE English Literature",
      imageUrl: Claire,
      position: "Assistant Director | Head of People and Operations",
      description:
        "Claire is the Assistant Director and Head of People and Operations at TutorWo. She achieved an ATAR of 96.85 and is currently studying Arts and Commerce at Monash University. As a culmination of her work within the VCE, Claire attained raw Study Scores of 47, 45, and 40 for Business Management, English and Literature respectively. She provides study tips, general support, and guidance in both broad and specific areas of focus that the student requires. Claire prioritises fostering a comfortable environment, whereby the student feels that their unique learning needs are met - in which, she adapts her sessions and teaching style to suit any student. Aside from studies, Claire enjoys playing the piano and cooking for friends and family in her spare time. She hopes that she can empower each and every one of her students, and that they will walk out of every session with a smile, along with feeling more confident, reassured, and knowledgeable.",
      //   subjects: [
      //     ["Primary English", languageTag],
      //     ["Primary Mathematics", numberTag],
      //     ["Secondary English", languageTag],
      //     ["VCE English", languageTag],
      //     ["VCE English Literature", languageTag],
      //   ],
    },
    {
      name: "Evelyn",
      role: "Primary English | Primary Mathematics | Secondary English | Secondary Mathematics",
      imageUrl: Evelyn,
      position: "Head of Teaching and Learning",
      description:
        "Evelyn is the Head of Teaching and Learning at TutorWo and at the same time, undertaking a Bachelor of Arts degree with a dual major in Geography and minors in Literary Studies and Chinese language. Complementing her Arts studies, she is also pursuing a Bachelor of Secondary Education (Honours), demonstrating a strong commitment to her future profession. Her academic foundation was laid at Presbyterian Ladies’ College, Melbourne, where she not only achieved a commendable ATAR of 91.25 but also developed leadership skills through her role as House Vice Captain. Evelyn possesses practical experience in education, having tutored both primary and secondary school students in the core subjects of Mathematics and English. Her interpersonal skills are a key asset; she is known for her approachable demeanor, which fosters open communication with students. This ability enables her to effectively understand and respond to their individual learning preferences and needs, ensuring a more personalized and effective tutoring experience. Beyond her academic and professional aspirations, Evelyn has personal interests that include the intricate construction of Lego sets and cherishing quality time spent with her cat, Muffin.",
      //   subjects: [
      //     ["Primary English", languageTag],
      //     ["Primary Mathematics", numberTag],
      //     ["Secondary English", languageTag],
      //     ["Secondary Mathematics", numberTag],
      //   ],
    },
  ];

  const [leaderToDisplay, setLeaderToDisplay] = useState(people);

  return (
    <div className="bg-white">
      <div className="mx-auto py-12 px-4 max-w-[89rem] sm:px-6 lg:px-52 lg:py-24">
        <div className="space-y-12">
          <motion.div
            variants={fadeUp}
            initial={"hidden"}
            whileInView={fadeUp.visible}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="flex flex-col justify-center gap-2">
            <p className="text-center text-blue text-5xl font-bold pb-5">
              Our Leadership
            </p>
          </motion.div>
          <ul className="text-center space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-2 lg:gap-x-8">
            {leaderToDisplay.map((person, index) => (
              <li key={person.name + index}>
                <div className="space-y-4 ">
                  {/* Tutor Image */}
                  <div className="aspect-w-3 aspect-h-2 relative  border-4 border-purple rounded-xl">
                    {person.imageUrl ? (
                      <img
                        className="object-cover h-[30rem] w-full shadow-lg rounded-lg "
                        src={person.imageUrl}
                        alt={person.name}
                      />
                    ) : (
                      <svg
                        className="object-cover h-[30rem] w-full rounded-full text-gray-300"
                        fill="currentColor"
                        viewBox="0 0 24 24">
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    )}
                  </div>
                  {/* Tutor details */}
                  <div className="space-y-2">
                    <div className=" text-2xl leading-6 font-medium space-y-1 text-blue">
                      <h3>{person.name}</h3>
                      <h4 className="text-purple pb-2 uppercase text-base">
                        {person.position}
                      </h4>
                    </div>
                    <button
                      data-index={index}
                      className="block w-30 py-1 px-4 mx-auto rounded-xl shadow bg-orange text-white font-medium hover:bg-yellow"
                      onClick={handleClick}>
                      View Profile
                    </button>
                  </div>
                </div>
              </li>
            ))}
            {/* MODAL */}
            {showModal && (
              <>
                <div className="fixed top-0 sm:top-32 lg:top-24 xl:top-30 2xl:top-[8%] 3xl:top-52 left-[5%] lg:left-[15%] xl:left-[25%] 2xl:left-[30%] bg-white border-2 border-purple scrollbar-thumb-grey scrollbar-thin scrollbar-cursor-pointer shadow-xl rounded-xl h-[38rem] sm:h-[32rem] lg:max-h-[120rem] 3xl:h-auto w-[90vw] mx-auto lg:w-[50vw] 2xl:w-[40vw] z-[200] overflow-y-scroll">
                  <XMarkIcon
                    className="hover:bg-yellow hover:ring-yellow w-10 h-10 float-right -translate-x-8 translate-y-8 p-2 rounded-lg text-white bg-purple ring-2 ring-offset-2 ring-purple shadow-lg cursor-pointer"
                    onClick={() => setShowModal(false)}
                  />
                  <div className="text-center mt-5 pb-5 lg:mt-8 border-b border-solid border-slate-200 rounded-t">
                    {leaderImage ? (
                      <img
                        className="m-auto w-40 h-40 mb-5 object-cover rounded-full"
                        src={leaderImage}
                        alt={leaderName}></img>
                    ) : (
                      <svg
                        className="m-auto w-40 h-40 mb-5 object-cover rounded-full text-gray-300"
                        fill="currentColor"
                        viewBox="0 0 24 24">
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    )}
                    <h3 className=" text-2xl font-semibold text-purple">
                      {leaderName}
                    </h3>
                  </div>
                  <div className="relative p-6 flex-auto">
                    <p className="my-4 text-blue text-md lg:text-lg leading-relaxed mb-8">
                      {leaderDescription}
                    </p>

                    <button
                      className="rounded-xl bg-purple text-white hover:bg-yellow font-bold uppercase text-sm px-6 py-3 shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-5 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}>
                      Close
                    </button>
                  </div>
                </div>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OurLeadership;
